import React, { Component } from 'react';
import injectSheet from 'react-jss';
import { gql } from 'apollo-boost';
import { Query } from 'react-apollo';
import {
  Media, CardImg, Button, TabContent, TabPane, Nav, NavItem, NavLink,
} from 'reactstrap';
import faker from 'faker';
import classnames from 'classnames';
import { Redirect, Link } from 'react-router-dom';
import _ from 'lodash';


import session from '../models/Session';
import uploadFailedIcon from 'react-fine-uploader/gallery/upload-failed-icon';

const styles = {
  cardContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    background: '#FFFFFF',
    // height: '100vh',
    padding: '90px 0 0 12rem',
  },
  cardLeft: {
    minWidth: '40.63rem',
    maxWidth: '40.63rem',
    borderRadius: 0,
  },
  cardRight: {

  },
  cardTitle: {
    fontFamily: 'Lato, Arial',
    fontSize: '0.875rem',
    color: '#1F1F1F',
    fontWeight: 'bold',
    marginBottom: '0.3125rem',
  },
  blurb: {
    fontFamily: 'Lato, Arial',
    fontSize: '0.875rem',
    color: '#656565',
    marginBottom: '1rem',
  },
  textWrapper: {
    minHeight: '4rem',
    borderBottom: '1px solid #DEE2E6',
    width: '37.5rem',
    marginBottom: '1rem',
    '&:last-child': {
      border: 0,
    },
  },
  image: {
    composes: ['image'],
    borderRadius: '0.375rem',
  },
  jamImageWrapper: {
    width: '37.5rem',
    height: '25rem',
    marginBottom: '1rem',
  },
  // participantsWrapper: {
  //   display: 'flex',
  //   flexWrap: 'wrap',
  // },
  spaces: {
    marginRight: '0.7rem',
  },
  confirmBtn: {
    background: '#34A5DA',
    fontFamily: 'Lato, Arial',
    fontSize: '1rem',
    color: '#FFFFFE',
    textAlign: 'center',
    width: '16.75rem',
    border: 0,
    '&:hover, :active': {
      background: '#34A5DA !important',
      color: '#FFFFFE !important',
      border: '0 !important',
    },
    '&:focus': {
      boxShadow: 'none',
    },
  },
  stage: {
    // marginTop: '7rem',
    transform: 'rotate(90deg)',
    MsTransform: 'rotate(90deg)', /* IE 9 */
    WebkitTransform: 'rotate(90deg)', /* Safari 3-8 */
    marginLeft: '-132px',
    marginTop: '-298px',
    // width: 'calc(100% - 103rem)',
    // position: 'absolute',
    // left: '32rem',
    // top: '77px',
  },
  templateLists: {
    marginLeft: '25px',
  },
  chipsName: {
    padding: '5px 10px',
    fontFamily: 'Lato, Arial',
    fontSize: '12px',
    color: '#1F1F1F',
    background: '#F2F3F1',
    borderRadius: '1.5rem',
    marginBottom: '2.2px',
    width: 'fit-content',
    fontWeight: 'bold',
  },
  timesJammedNumber: {
    fontFamily: 'Lato, Arial',
    fontSize: '28px',
    color: '#1F1F1F',
  },
  timesJammedLabel: {
    fontFamily: 'Lato, Arial',
    fontSize: '14px',
    color: '#1F1F1F',
    marginBottom: '0.4rem',
  },
  jamBtn: {
    width: '16.75rem',
    background: '#34A5DA',
    color: '#FFFFFF',
    fontFamily: 'Lato, Arial',
    fontSize: '1rem',
    border: 'none',
    '&:hover, :active': {
      background: '#34A5DA !important',
      color: '#FFFFFE !important',
      border: '0 !important',
    },
    '&:focus': {
      boxShadow: 'none',
    },
  },
  divider: {
    marginTop: 0,
    marginBottom: 0,
  },
  tabContent: {
    marginLeft: '12rem',
  },
  tabs: {
    marginBottom: '1rem',
  },
  firstTab: {
    color: '#656565',
    marginLeft: '12rem',
  },
  secondTab: {
    color: '#656565',
  },
  navLink: {
    cursor: 'pointer',
    border: 'none !important',
    '&.active': {
      borderBottom: '1px solid #34A5DA !important',
      color: '#34A5DA !important',
    },
  },
  participantsWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  imageWrapper: {
    width: '2rem',
    height: '2rem',
    display: 'flex',
    position: 'relative',
    overflow: 'hidden',
    fontSize: '1.25rem',
    flexShrink: 0,
    fontFamily: 'Lato',
    alignItems: 'center',
    userSelect: 'none',
    borderRadius: '50%',
    justifyContent: 'center',
  },
  userName: {
    marginLeft: '0.5rem',
    marginRight: '0.5rem',
    fontFamily: 'Lato, Arial',
    fontSize: '0.875rem',
    color: '#1F1F1F',
    fontWeight: 'bold',
    lineHeight: '1.875rem',
  },
  jamLeaderInfoWrapper: {
    width: '37.5rem',
  },
  userInfoWrapper: {
    display: 'flex',
    marginBottom: '1rem',
    border: '1px solid #E5E7E6',
    borderRadius: '1.5rem',
    padding: '0.1875rem',
    cursor: 'default',
  },
  chipWrapper: {
    composes: ['chip-wrapper'],
    margin: '0.2rem',
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #E5E7E6',
    borderRadius: '1.5rem',
    padding: '0.1875rem 1rem 0.1875rem 0.1875rem',
    width: 'max-content',
  },
  wrapper: {
    height: '100vh',
    display: 'grid',
  },
  participantsContainer: {
    background: '#FFFFFF',
  },
  cardBody: {
    flex: '1 1 auto',
    padding: '1.25rem 0',
  },
  rejamBtn: {
    cursor: 'pointer',
    fontFamily: 'Lato, Arial',
    fontSize: '0.875rem',
    color: '#34A5DA',
    textAlign: 'center',
    '&:hover': {
      textDecoration: 'none',
      color: '#34A5DA',
    },
  },
  linkWrapper: {
    textAlign: 'center',
  },
  stages: {
    width: '20px',
  },
};

const GET_DRAFT_BY_ID = id => gql`
  query {
    templateMany {
      name
    }
    draftById(_id: "${id}") {
      _id
      title,
      blurb,
      image,
      __typename,
      template {
        _id,
        name,
        slug
      }
    }
  }
`;


const GET_STORY_BY_ID = id => gql`
query {
  templateMany {
    name
  }
  storyById(_id: "${id}") {
    _id,
    title,
    blurb,
    slug,
    image,
    __typename,
    fields,
    draft
    template {
      _id,
      name,
      slug
      children {
        _id, 
        name, 
        slug
      }
    }
    participants {
      displayName,
      image
    }
    createdBy {
      displayName
      image
    }
  }
}
`;

function TemplateChips(props) {
  const { classes, templates, match } = props;
  return templates.map((template, index) => (
    <div key={index} className={classes.chipsName}>{match.params.type === 'jam' ? `${template.name  } Jam` : template.name }</div>
  ));
}

const createdBy = {
  displayName: faker.name.findName(),
  image: faker.image.avatar(),
};

class FullPageJamDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: '1',
      draft: null,
    };
  }

  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  renderParticipants = (classes, data) => {
    const participantsMocked = [
      {
        displayName: faker.name.findName(),
        image: faker.image.avatar(),
      },
      {
        displayName: faker.name.findName(),
        image: faker.image.avatar(),
      },
      {
        displayName: faker.name.findName(),
        image: faker.image.avatar(),
      },
    ];

    let participants = data.length > 0 ? data : participantsMocked;

      console.log("datadatadatadata", data)
    return participants.map((participant, index) => (
      <div key={index} className={classnames(classes.spaces, classes.userInfoWrapper)}>
        <div className={classes.imageWrapper}>
          <Media
            src={participant.image || require(`../assets/userDefaultImage.png`)}
            className={classes.image}
            alt="Generic placeholder image"
          />
        </div>
        <div className={classes.userName}>
          {participant.displayName}
        </div>
      </div>
    ))
    }

  render() {
    const {
      classes, labelTooltip, blurb, image, number, timesJammed, typeName, onClick,
    } = this.props;
    let getQuery = null;
    console.log(this.props.match);

    if (this.props.match.params.type === 'new') {
      if (this.state.draft) {
        return (
          <Redirect to={`/card/detail/jam/${this.state.draft._id}`} />
        );
      }

      if (this.state.story) {
        return (
          <Redirect to={`/card/detail/fruit/${this.state.story._id}`} />
        );
      }

      const draft = session.get('draft');
      const story = session.get('story');

      if (draft) {
        const queryString = new URLSearchParams(window.location.search);
        if (queryString.get('isSeeded')) {
          draft.syncCreate({ isSeeded: true }).then(() => {
            this.setState({
              draft: draft,
            });
          }).catch(console.error);
        }
      }

      if (story) {
        story.syncCreate().then(() => {
          this.setState({
            story: story,
          });
        }).catch(console.error);
      }

      return (<div />);
    }

    if (this.props.match.params.type === 'fruit') {
      getQuery = GET_STORY_BY_ID(this.props.match.params.id);
    }
    if (this.props.match.params.type === 'jam') {
      getQuery = GET_DRAFT_BY_ID(this.props.match.params.id);
    }

    return (
      <Query query={getQuery}>
        {({ loading, error, data }) => {
          if (loading) return <div>Loading...</div>;
          if (error) return <div>Error :(</div>;

          console.log('Got query result', loading, error, data);

          let resultQuery = null;
          let btnLabel = null;
          let templateIndex = null;

          if (!(data && (data.storyById || data.draftById))) {
            return null;
          }

          if (this.props.match.params.type === 'fruit') {
            resultQuery = data.storyById;
            templateIndex = _.findIndex(data.templateMany, template => template.name === data.storyById.template.name);
            btnLabel = `Create ${resultQuery.template.name} Jam`;
          }
          if (this.props.match.params.type === 'jam') {
            resultQuery = data.draftById;
            templateIndex = _.findIndex(data.templateMany, template => template.name === data.draftById.template.name);
            btnLabel = `Start ${resultQuery.template.name} Jam`;
          }

          return (
            <div className={classes.wrapper}>
              <div className={classes.cardContainer}>
                <div className={classes.cardLeft}>
                  <div className={classes.jamImageWrapper}>
                    <Media
                      src={resultQuery.image || image || faker.image.avatar()}
                      className={classes.image}
                      alt="Generic placeholder image"
                    />
                  </div>
                  <div>
                    <div className={classes.cardTitle}>
                      {`${resultQuery.template.name || typeName} Title:`}
                    </div>
                    <div className={classes.blurb}>
                      {resultQuery.title || labelTooltip}
                    </div>
                    <div className={classes.cardTitle}>
                      {`${resultQuery.template.name || typeName} Blurb:`}
                    </div>
                    <div className={classes.blurb}>
                      {resultQuery.blurb || blurb}
                    </div>
                  </div>
                </div>
                <div className={classes.cardRight}>
                  <div className={classes.templateLists}>
                    <TemplateChips match={this.props.match} classes={classes} templates={data.templateMany} />
                  </div>
                  <CardImg top className={classes.stages} width="100%" src={require(`../assets/photos/Jam${templateIndex+1}.svg`)} alt="Card image cap" />
                  <div className={classes.timesJammedNumber}>{timesJammed || Math.floor(Math.random() * 1000) + 1 } </div>
                  <div className={classes.timesJammedLabel}>#times jammed</div>
                  
                  { this.props.match.params.type === 'jam' ? (
                    <Link className={classes.rejamBtn} to={`/crew/${resultQuery._id}/new`}>
                      <Button className={classes.jamBtn}>{btnLabel}</Button>
                    </Link>
                  ) : ''}
 
                  
                  
                  
                  { this.props.match.params.type === 'fruit'
                      ? (
                        <div>
                          {
                            resultQuery.template.children.map(c => {
                              return (
                                <Link className={classes.rejamBtn} to={`/create/${c.slug}/select?parents[]=${resultQuery._id}`} key={c._id}>
                                  <Button className={classes.jamBtn}>Create {c.name} Jam</Button>
                                </Link>
                              )
                            })
                          }

                          <div className={classes.linkWrapper}>
                            <Link className={classes.rejamBtn} to={`/crew/${resultQuery.draft}/new`}>Rejam This Fruit</Link>
                          </div>
                        </div>
                      )
                      : ''
                  }
                </div>
              </div>
              {
                this.props.match.params.type === 'fruit'
                  ? (
                    <div className={classes.participantsContainer}>
                      <hr className={classes.divider} />
                      <div className={classes.cardBody}>
                        <Nav tabs className={classes.tabs}>
                          <NavItem className={classes.firstTab}>
                            <NavLink
                              className={classnames({ active: this.state.activeTab === '1' }, classes.navLink)}
                              onClick={() => { this.toggle('1'); }}
                            >
                              <div>Participant(s)</div>
                            </NavLink>
                          </NavItem>
                          <NavItem className={classes.secondTab}>
                            <NavLink
                              className={classnames({ active: this.state.activeTab === '2' }, classes.navLink)}
                              onClick={() => { this.toggle('2'); }}
                            >
                              <div>Sessions &amp; Notes</div>
                            </NavLink>
                          </NavItem>
                        </Nav>
                        <TabContent className={classes.tabContent} activeTab={this.state.activeTab}>
                          <TabPane tabId="1">
                            <div className={classes.cardTitle}>
                              Jam Leader(s):
                            </div>
                            <div className={classnames(classes.jamLeaderInfoWrapper, classes.userInfoWrapper)}>
                              <div className={classes.imageWrapper}>
                                <Media
                                  src={resultQuery.createdBy.image || createdBy.image || require(`../assets/userDefaultImage.png`)}
                                  className={classes.image}
                                  alt="Generic placeholder image"
                                />
                              </div>
                              <div className={classes.userName}>
                                {resultQuery.createdBy.displayName || createdBy.displayName}
                              </div>
                            </div>
                            <div>
                              <div className={classes.cardTitle}>
                                Participant(s):
                              </div>
                              <div className={classes.participantsWrapper}>
                                {this.renderParticipants(classes, data.storyById.participants)}
                              </div>
                            </div>
                          </TabPane>
                          <TabPane tabId="2">
                          { resultQuery.fields ?  
                            (<div>
                              {resultQuery.fields.session_1_notes ? <RenderSessionAndNotes classes={classes} blurb={resultQuery.fields.session_1_notes} label="Session 1 Note:" /> : ''}
                              {resultQuery.fields.session_2_notes ? <RenderSessionAndNotes classes={classes} blurb={resultQuery.fields.session_2_notes} label="Session 2 Note:" /> : ''}
                              {resultQuery.fields.session_3_notes ? <RenderSessionAndNotes classes={classes} blurb={resultQuery.fields.session_3_notes} label="Session 3 Note:" /> : ''}
                              {resultQuery.fields.session_4_notes ? <RenderSessionAndNotes classes={classes} blurb={resultQuery.fields.session_4_notes} label="Session 4 Note:" /> : ''}
                              {resultQuery.fields.session_5_notes ? <RenderSessionAndNotes classes={classes} blurb={resultQuery.fields.session_5_notes} label="Session 5 Note:" /> : ''}
                              {resultQuery.fields.story_blurb ? <RenderSessionAndNotes classes={classes} blurb={resultQuery.fields.story_blurb} label="Blurb:" /> : ''}
                              {resultQuery.fields.genre ? <RenderSessionAndNotes classes={classes} blurb={resultQuery.fields.tagline} label="Tagline:" /> : ''}
                              {resultQuery.fields.genre ? <RenderSessionAndNotes classes={classes} blurb={resultQuery.fields.genre} label="Genre:" /> : ''}
                              {resultQuery.fields.logline ? <RenderSessionAndNotes classes={classes} blurb={resultQuery.fields.logline} label="Logline:" /> : ''}
                              {resultQuery.fields.dramatic_question ? <RenderSessionAndNotes classes={classes} blurb={resultQuery.fields.dramatic_question} label="Dramatic Question:" /> : ''}
                              {resultQuery.fields.act_1 ? <RenderSessionAndNotes classes={classes} blurb={resultQuery.fields.act_1} label="Act 1:" /> : ''}
                              {resultQuery.fields.act_1_part_1 ? <RenderSessionAndNotes classes={classes} blurb={resultQuery.fields.act_1_part_1} label="Act 1 Part 1:" /> : ''}
                              {resultQuery.fields.act_1_part_2 ? <RenderSessionAndNotes classes={classes} blurb={resultQuery.fields.act_1_part_2} label="Act 1 Part 2:" /> : ''}
                              {resultQuery.fields.act_1_part_3 ? <RenderSessionAndNotes classes={classes} blurb={resultQuery.fields.act_1_part_3} label="Act 1 Part 3:" /> : ''}
                              {resultQuery.fields.act_2 ? <RenderSessionAndNotes classes={classes} blurb={resultQuery.fields.act_2} label="Act 2:" /> : ''}
                              {resultQuery.fields.act_2_part_1 ? <RenderSessionAndNotes classes={classes} blurb={resultQuery.fields.act_2_part_1} label="Act 2 Part 1:" /> : ''}
                              {resultQuery.fields.act_2_part_2 ? <RenderSessionAndNotes classes={classes} blurb={resultQuery.fields.act_2_part_2} label="Act 2 Part 2:" /> : ''}
                              {resultQuery.fields.act_2_part_3 ? <RenderSessionAndNotes classes={classes} blurb={resultQuery.fields.act_2_part_3} label="Act 2 Part 3:" /> : ''}
                              {resultQuery.fields.act_3 ? <RenderSessionAndNotes classes={classes} blurb={resultQuery.fields.act_3} label="Act 3:" /> : ''}
                              {resultQuery.fields.act_3_part_1 ? <RenderSessionAndNotes classes={classes} blurb={resultQuery.fields.act_3_part_1} label="Act 3 Part 1:" /> : ''}
                              {resultQuery.fields.act_3_part_2 ? <RenderSessionAndNotes classes={classes} blurb={resultQuery.fields.act_3_part_2} label="Act 3 Part 2:" /> : ''}
                              {resultQuery.fields.act_3_part_3 ? <RenderSessionAndNotes classes={classes} blurb={resultQuery.fields.act_3_part_3} label="Act 3 Part 3:" /> : ''}
                              {resultQuery.fields.fears ? <RenderSessionAndNotes classes={classes} blurb={resultQuery.fields.fears} label="Fears:" /> : ''}
                              {resultQuery.fields.needs ? <RenderSessionAndNotes classes={classes} blurb={resultQuery.fields.needs} label="Needs:" /> : ''}
                              {resultQuery.fields.objectives ? <RenderSessionAndNotes classes={classes} blurb={resultQuery.fields.objectives} label="Objectives:" /> : ''}
                              {resultQuery.fields.virtue_vices ? <RenderSessionAndNotes classes={classes} blurb={resultQuery.fields.virtue_vices} label="Virtue Vices:" /> : ''}
                              {resultQuery.fields.wants ? <RenderSessionAndNotes classes={classes} blurb={resultQuery.fields.wants} label="Wants:" /> : ''}
                            </div>) : 'There are no Sessions and Notes'
                          }
                          </TabPane>
                        </TabContent>
                      </div>
                    </div>
                  ) : ''
              }
            </div>
          );
        }}
      </Query>
    );
  }
}

function RenderSessionAndNotes(props) {
  const { classes, label, blurb } = props;
  return (
    <div className={classes.textWrapper}>
      <div className={classes.cardTitle}>
        {label}
      </div>
      <div className={classes.blurb} dangerouslySetInnerHTML={{__html: blurb}} />
    </div>
  );
}

export default injectSheet(styles)(FullPageJamDetail);




// WEBPACK FOOTER //
// ./src/pages/FullPageJamDetail.js